import AuthLayout from '@authentication/components/AuthLayout';
import ResetPasswordCard from '@authentication/components/molecules/ResetPasswordCard';

function ResetPasswordPage() {
  return (
    <AuthLayout>
      <ResetPasswordCard />
    </AuthLayout>
  );
}

export default ResetPasswordPage;
